module.exports = __webpack_public_path__ + "img/vu.08f0699d.png";